import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./CustomDialog.module.scss";

export default function CustomDialog({
  title,
  content,
  onAccept,
  onClose,
  acceptButtonLabel = "Yes",
  showCancelButton = true,
  showCloseButton = true,
  disableBackdropClose = false,
  disableEscapeKeyDown = false,
}: {
  title: string;
  content: string;
  onClose: () => void;
  onAccept: () => void;
  acceptButtonLabel?: string;
  showCancelButton?: boolean;
  showCloseButton?: boolean;
  disableBackdropClose?: boolean;
  disableEscapeKeyDown?: boolean;
}) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const acceptHandler = () => {
    handleClose();
    onAccept();
  };

  const handleDialogClose = (
    event: object,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason === "backdropClick" && disableBackdropClose) return;
    if (reason === "escapeKeyDown" && disableEscapeKeyDown) return;
    handleClose();
  };

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={handleDialogClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xs"
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      <DialogTitle className={classes.dialogTitle}>
        <span>{title}</span>
        {showCloseButton && (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <DialogContentText 
          id="alert-dialog-slide-description"
          sx={{ color: 'black' }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogAction} sx={{ justifyContent: 'center' }}>
        {showCancelButton && (
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        )}
        <Button variant="contained" onClick={acceptHandler}>
          {acceptButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
